// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ejW0","option":"styles_option__1XKC0","active":"styles_active__jZ9RZ"};